/**
 * AnnotationPropertiesComponent
 * Angular clone of Magic Patterns media/AnnotationProperties.tsx — right sidebar to
 * edit the selected annotation (description, opacity, stroke, fill, lock, delete).
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Annotation } from './media-annotation.types';

@Component({
  standalone: false,
  selector: 'app-doc-annotation-properties',
  templateUrl: './doc-annotation-properties.component.html',
  styleUrls: ['./doc-annotation-properties.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocAnnotationPropertiesComponent {
  @Input() annotation!: Annotation;

  @Output() update = new EventEmitter<Partial<Annotation>>();
  @Output() deleteAnnotation = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  // MP AnnotationProperties fill palette (orange, red, blue, green, white, black).
  readonly fillColors = ['#FF6B35', '#EF4444', '#3B82F6', '#10B981', '#FFFFFF', '#000000'];

  get isShape(): boolean {
    return this.annotation.type === 'rectangle' || this.annotation.type === 'circle';
  }
  get isMeasure(): boolean {
    return this.annotation.type === 'ruler' || this.annotation.type === 'area';
  }
  get title(): string {
    return this.annotation.type.charAt(0).toUpperCase() + this.annotation.type.slice(1);
  }
  get when(): string {
    return new Date(this.annotation.timestamp).toLocaleString();
  }

  setDescription(v: string): void { this.update.emit({ description: v }); }
  setOpacity(v: number): void { this.update.emit({ opacity: v }); }
  setStroke(v: number): void { this.update.emit({ strokeWidth: v }); }
  setFill(c: string | undefined): void { this.update.emit({ fillColor: c }); }
  toggleLock(): void { this.update.emit({ locked: !this.annotation.locked }); }
}
